import React from 'react';
import styled from 'styled-components';
import { DefaultButton } from './DefaultButton.jsx';

const Readout = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: 1.75fr 1fr;
  margin-top: 1rem;
  border-top: 1px solid ${(props) => props.theme.primaryColor};
  border-bottom: 1px solid ${(props) => props.theme.primaryColor};

  h3 {
    font-size: clamp(1.5rem, calc(-0.875rem + 8.333333vw), 2.25rem);
  }

  h4 {
    font-size: clamp(1rem, calc(-0.875rem + 8.333333vw), 1.5rem);
  }

  h5 {
    font-size: clamp(.85rem, calc(-0.875rem + 8.333333vw), 1.35rem);
    padding: .2em;
  }

  p {
    font-size: clamp(.75rem, calc(-0.875rem + 8.333333vw),.85rem);
    line-height: 1.2em;
  }
`

const ScanDisplay = styled(DefaultButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding-bottom: .25em;
`

const ScanLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding-bottom: .25em;
`

const Label = styled(ScanLabel)`
  border-top: 1px solid ${(props) => props.theme.primaryColor};
  border-right: 1px solid ${(props) => props.theme.primaryColor};
`

const Data = styled(ScanDisplay)`
  border-right: 1px solid ${(props) => props.theme.primaryColor};
`

const DiameterLabel = styled(Label)`
  grid-area: 2 / 1 / 3 / 2;
`
const DiameterData = styled(Data)`
  grid-area: 1 / 1 / 2 / 2;
`
const TempLabel = styled(Label)`
  grid-area: 2 / 2 / 3 / 3;
`
const TempData = styled(Data)`
  grid-area: 1 / 2 / 2 / 3;
`
const GravLabel = styled(Label)`
  grid-area: 2 / 3 / 3 / 4;
`
const GravData = styled(Data)`
  grid-area: 1 / 3 / 2 / 4;
`
const HourLabel = styled(Label)`
  grid-area: 2 / 4 / 3 / 5;
`
const HourData = styled(Data)`
  grid-area: 1 / 4 / 2 / 5;
`
const ChemLabel = styled(ScanLabel)`
  border-top: 1px solid ${(props) => props.theme.primaryColor};
  grid-area: 2 / 5 / 3 / 6;
`
const ChemData = styled(ScanDisplay)`
  grid-area: 1 / 5 / 2 / 6;
  flex-direction: row;
  flex-wrap: wrap;
`

const ScanReadout = ({ temperature, gravity, commonElements, rareElement, diameter, hoursPerDay, reroll }) => {
  return (
    <Readout>
      <DiameterData onClick={() => reroll('size')}>
        <h4>{`${diameter}`}</h4>
      </DiameterData>
      <DiameterLabel>
        <p>DIAMETER (km)</p>
      </DiameterLabel>
      <TempData onClick={() => reroll('temperature')}>
        <h3>{`${temperature}°`}</h3>
      </TempData>
      <TempLabel>
        <p>AVG TEMP (c)</p>
      </TempLabel>
      <GravData onClick={() => reroll('gravity')}>
        <h3>{`${gravity}`}</h3>
      </GravData>
      <GravLabel>
        <p>GRAVITY (g)</p>
      </GravLabel>
      <HourData onClick={() => reroll('hours')}>
        <h3>{hoursPerDay}</h3>
      </HourData>
      <HourLabel>
        <p>HOURS PER DAY</p>
      </HourLabel>
      <ChemData onClick={() => reroll('elements')}>
        <h5>{commonElements[0].description}</h5>
        <h5>{commonElements[1].description}</h5>
        <h5>{rareElement.description}</h5>
      </ChemData>
      <ChemLabel>
        <p>PROMINENT ELEMENTS</p>
      </ChemLabel>
    </Readout>
  )
}

export default ScanReadout
